import {showKeyboardAwareAlert} from './keyboard';

export const showDeleteUnitPrompt = (title: string, callbackFn: () => void) => {
  showKeyboardAwareAlert(
    '',
    `Do you really want to exit this ${title} ?`,
    [
      {
        text: 'NO',
        onPress: () =>  console.log('Cancel Pressed'),
        style: 'cancel',
      },
      {
        text: 'YES',
        onPress: () => callbackFn(),
      },
    ],
    {
      cancelable: true,
    },
  );
};
